import { render } from "./Menu.vue?vue&type=template&id=94f4606e"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=94f4606e&lang=css"

import exportComponent from "D:\\project\\lm-pgac\\PGAC-source\\pgac-600090-ob-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__